/* DNAcademy auth session module.
   Talks ONLY to the platform Worker API — never to Supabase directly. */
(() => {
  const API = 'https://dnacademy-platform.patrickmadethis.workers.dev';
  const KEY = 'dna_session';

  const getSessionSync = () => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const s = JSON.parse(raw);
      if (!s || typeof s.access !== 'string' || typeof s.refresh !== 'string') return null;
      return s;
    } catch (_) { return null; }
  };

  const setSession = (tokens) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({
        access: tokens.access_token,
        refresh: tokens.refresh_token,
        exp: Date.now() + (tokens.expires_in - 60) * 1000
      }));
    } catch (_) { /* storage unavailable — session lives for this page only */ }
  };

  const clear = () => { try { localStorage.removeItem(KEY); } catch (_) {} };

  let refreshing = null; // single in-flight refresh
  const refresh = () => {
    if (refreshing) return refreshing;
    const s = getSessionSync();
    if (!s) return Promise.resolve(null);
    refreshing = fetch(API + '/api/refresh', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: s.refresh })
    }).then(async (res) => {
      if (!res.ok) { clear(); return null; }
      const tokens = await res.json();
      setSession(tokens);
      return tokens.access_token;
    }).catch(() => null).finally(() => { refreshing = null; });
    return refreshing;
  };

  const token = async () => {
    const s = getSessionSync();
    if (!s) return null;
    if (Date.now() < s.exp) return s.access;
    return refresh();
  };

  const api = async (path, opts) => {
    opts = opts || {};
    const doFetch = async (access) => {
      const headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
      if (access) headers['Authorization'] = 'Bearer ' + access;
      return fetch(API + path, Object.assign({}, opts, { headers }));
    };
    let access = await token();
    let res = await doFetch(access);
    if (res.status === 401 && getSessionSync()) {
      access = await refresh();
      if (access) res = await doFetch(access);
    }
    return res;
  };

  const parseOrThrow = async (res) => {
    let data = null;
    try { data = await res.json(); } catch (_) { data = null; }
    if (!res.ok) throw (data && typeof data === 'object' ? data : { error: 'request_failed' });
    return data;
  };

  const login = async (email, password) => {
    const res = await fetch(API + '/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await parseOrThrow(res);
    setSession(data);
    return data;
  };

  const setPassword = async (token_hash, type, password) => {
    const res = await fetch(API + '/api/set-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token_hash, type, password })
    });
    const data = await parseOrThrow(res);
    setSession(data);
    return data;
  };

  const setPasswordWithSession = async (payload) => {
    const res = await fetch(API + '/api/set-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await parseOrThrow(res);
    setSession(data);
    return data;
  };

  const resetRequest = async (email) => {
    const res = await fetch(API + '/api/reset-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    return parseOrThrow(res);
  };

  const requireAuth = async () => {
    const access = await token();
    if (!access) {
      location.href = '/pages/course-login?next=' +
        encodeURIComponent(location.pathname + location.search);
      return null;
    }
    return access;
  };

  const logout = () => { clear(); location.href = '/'; };

  window.DNA = window.DNA || {};
  window.DNA.auth = {
    setSession, getSessionSync, clear, token, api,
    login, setPassword, setPasswordWithSession, resetRequest, requireAuth, logout
  };

  // ---- Nav awareness: logged-in visitors see "My courses" instead of "Log in".
  const enhanceNav = () => {
    if (!getSessionSync()) return;
    const links = [
      ...document.querySelectorAll('.nav__login'),
      ...document.querySelectorAll('.nav__overlay nav a:last-child')
    ];
    links.forEach((a) => {
      a.textContent = 'My courses';
      a.setAttribute('href', '/pages/my-courses');
    });
  };

  // ---- Sales-page awareness: entitled owners get a "Continue watching" CTA.
  const enhanceSalesPage = async () => {
    const root = document.querySelector('[data-course-handle]');
    if (!root || !getSessionSync()) return;
    const handle = root.getAttribute('data-course-handle');
    if (!handle) return;
    try {
      const res = await api('/api/me');
      if (!res.ok) return;
      const me = await res.json();
      if (!me || !Array.isArray(me.courses) || !me.courses.includes(handle)) return;
      const ctas = document.querySelector('.hero__ctas');
      if (!ctas) return;
      const a = document.createElement('a');
      a.className = 'btn btn--ghost';
      a.href = '/pages/classroom?course=' + encodeURIComponent(handle);
      a.textContent = 'Continue watching →';
      ctas.appendChild(a);
    } catch (_) { /* stay quiet on the sales page */ }
  };

  enhanceNav();
  enhanceSalesPage();
})();
